<template>
    <div class="import-summary-container">
        <div
            class="summary-field-container"
            v-for="field in fields"
            :key="field.label"
        >
            <v-icon v-if="!field.pngSrc" :size="field.size">{{ field.icon }}</v-icon>
            <img v-if="field.pngSrc" :src="field.pngSrc" :style="{ width: field.width, height: field.height }"/>
            <p>
                {{ field.label }}:
            </p>
            <p>
                {{ field.value }}
            </p>
        </div>
    </div>
</template>
  
<script>
    export default {
        name: "ImportsSummary",

        props: {
            fields: {
                type: Array
            }
        },
    };
</script>
  
<style scoped>
    .import-summary-container{
        height: 100%;
        display: flex;
        justify-content: start;
        flex-direction: column;
        padding-top: 24px;
        gap: 24px;
    }
    .summary-field-container{
        display: flex;
        gap: 13px;
        align-items: bottom;
    }
    .summary-field-container p{
        margin: 0;
        line-height: 11.5px;
        font-weight: 400;
        font-size: 11.5px;
    }
    .v-icon {
        color: #29BDF0;
    }
</style>
  


// WEBPACK FOOTER //
// src/newComponents/Data/Imports/ImportsSummary.vue